import { mapDictionaryKey } from "components/Filters/helpers";

import { ContextsSuggestions, SEARCH_CONTEXTS_SUGGESTIONS_DICTIONARY } from "../constants";

export const getFilterKey = (key: ContextsSuggestions | string) => {
  return mapDictionaryKey(key, SEARCH_CONTEXTS_SUGGESTIONS_DICTIONARY);
};
